import { atom, useAtom, useAtomValue } from 'jotai'
import { useCallback, useEffect } from 'react'
import useScript from 'react-script-hook/lib/use-script'

declare global {
    interface Window {
        Telegram:any;
    }
}

const TG_SCRIPT_URL = 'https://telegram.org/js/telegram-web-app.js'

const webAppAtom = atom<any>(null)

export const useTgWebAppSdk = (tgBotUrl: string) => {
  const [loading, error] = useScript({ src: TG_SCRIPT_URL })
  const [webApp, setWebApp] = useAtom(webAppAtom)

  useEffect(() => {
    if (loading) return
    if (webApp) return
    const _webApp = window.Telegram?.WebApp
    _webApp?.ready()
    const isReady = !!_webApp?.initData || false
    if (isReady) _webApp.BackButton.hide()
    setWebApp({
      ready: isReady,
      tgBotUrl,
      webApp:_webApp,
    })
  }, [loading, webApp, setWebApp, tgBotUrl])

  return {isWebAppReady: !!webApp, error}

}

export const useTgWebApp = () => {
  const {ready, tgBotUrl, webApp} = useAtomValue(webAppAtom)

  const expandWebApp = useCallback(() => {
    if (!webApp?.isExpanded) return
    webApp.expand()
  }, [webApp])

  const closeWebApp = useCallback((startPayload?: string) => {
    if (!webApp) return
    const startCommand = startPayload ? `?start=${startPayload}`:''
    const botUrl = `${tgBotUrl}${startCommand}`
    console.log('ACZ: webbApp',{ready, tgBotUrl, webApp})
    webApp.openTelegramLink(botUrl)
  }, [webApp, tgBotUrl])

  return {ready, closeWebApp, expandWebApp}
}

